import { render } from "./VRParkNingboScience.vue?vue&type=template&id=64ee228a&scoped=true"
import script from "./VRParkNingboScience.vue?vue&type=script&lang=js"
export * from "./VRParkNingboScience.vue?vue&type=script&lang=js"

import "@/assets/css/cases.css?vue&type=style&index=0&id=64ee228a&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ee228a"]])

export default __exports__